module.exports = __webpack_public_path__ + "static/media/tinyLock.9aa4c1d2.svg";